import { WizTranslationManager } from '@wizeoo/akm-component-lib';

/** fausse codif des constantes du viewData */
export class FakeVO {
  /**
   * constructeur composite
   */
  public constructor(code: string, label: string, order: number, datakind?: string, format?: string, icon?: string) {
    this.code = code;
    this.label = label;
    this.order = order;
    this.trsLabel = WizTranslationManager.getInstance().translateKey(label);
    this.fulltrsLabel = this.trsLabel + ' (' + this.code + ')';
    this.datakind = datakind;
    this.format = format;
    this.icon = icon;
  }

  code: string;
  label: string;
  order: number = 100;
  trsLabel: string; // label traduit
  fulltrsLabel: string; // label traduit (code)
  datakind: string = null; // type de données
  format: string = null; // référence à un format de données
  icon: string = null; // rendu matIcon


  public get labelOrDefaultLabel(): string {
    return this.trsLabel;
  }

}
